import axios from "@/axios";

export const namespaced = true;

const defaultData = {
  orderId: 0,
  lineItemId: 0,
  itemNumber: null,
  fundCitationName: null,
  stockClassId: null,
  stockSubClassId: null,
  stockDescription: null,
  unitMeasureId: null,
  requestedQuantity: null,
  receivedQuantity: null,
  unitPrice: null,
};

export const state = {
  lineItems: [],
  lineItem: Object.assign({}, defaultData),
  lineItemStatus: false,
  lineItemErrors: [],
};

export const getters = {
  lineItems: (state) => {
    let lineItems = [];
   
    if (state.lineItems) {
      let lineItemNumbers = state.lineItems
        .filter((lineItem) => parseInt(lineItem.itemNumber))
        .map((lineItem) => {
          return { ...lineItem, itemNumber: parseInt(lineItem.itemNumber) };
        });

      let lineItemStrings = state.lineItems.filter(
        (lineItem) => !parseInt(lineItem.itemNumber)
      );

      lineItemNumbers = lineItemNumbers.sort();
      if (lineItemStrings) {
        lineItemStrings = lineItemStrings.sort();
        lineItems = lineItemNumbers.concat(lineItemStrings);
      } else {
        lineItems = lineItemNumbers;
      }
      for(var i=0; i<lineItems.length; i++) {
        lineItems[i]['requestedQuantity'] = parseFloat(lineItems[i]['requestedQuantityStr']) || 0;
        lineItems[i]['receivedQuantity'] = parseFloat(lineItems[i]['receivedQuantityStr']) || null;
        lineItems[i]['unitPrice'] = parseFloat(lineItems[i]['unitPriceStr']) || 0;
      }
      return lineItems;
    }
  },
  lineItem: (state) => state.lineItem,
  lineItemStatus: (state) => state.lineItemStatus,
  lineItemErrors: (state) => state.lineItemErrors,
};

export const mutations = {
  SET_LINE_ITEM: (state, response) => {
    response.data['requestedQuantity'] = parseFloat(response.data['requestedQuantityStr']) || 0;
    response.data['receivedQuantity'] = parseFloat(response.data['receivedQuantityStr']) || null;
    response.data['unitPrice'] = parseFloat(response.data['unitPriceStr']) || 0;
    state.lineItem = Object.assign({}, defaultData, response.data);
  },
  SET_LINE_ITEMS: (state, response) => {
    state.lineItems = response.data;
  },
  CLEAR_LINE_ITEM_DATA: (state) => {
    state.lineItem = Object.assign({}, defaultData);
  },
  SET_LINE_ITEM_STATUS(state, status) {
    state.lineItemStatus = status;
  },
  CLEAR_SUB_CLASS: (state) => {
    state.lineItem.stockSubClassId = null;
  },
  SET_ERRORS(state, data) {
    state.lineItemErrors = data;
  },
  CLEAR_ERRORS(state) {
      state.lineItemErrors = [];
  }
};

export const actions = {
  async getLineItem({ commit, state }, id) {
    var lineItem = await axios.get(`/api/lineitems/${id}`);
    commit("SET_LINE_ITEM", lineItem);
  },

  async getLineItems({ commit, state }, orderId) {
    var id = orderId;
    commit(
      "SET_LINE_ITEMS",
      await axios.get(`/api/lineitems/order/${orderId}`)
    );
  },
  async getLineItemStatus({ commit }, id) {
    if (id == 0) {
      commit("SET_LINE_ITEM_STATUS", false);
    } else {
      return await axios
        .get("/api/lineitems/status/" + id)
        .then(({ data }) => {
          if(data && data.length === 0) {
            commit("SET_LINE_ITEM_STATUS", true);
            commit("CLEAR_ERRORS");
        } else {
          commit("SET_LINE_ITEM_STATUS", false);
            commit("SET_ERRORS", data);
        }
        });
    }
  },
  async saveLineItem({ state }, id) {
    state.lineItem.orderId = id;
    return await axios.post("/api/lineitems/", state.lineItem, { config:{ showToast: true}});
  },
  async removeLineItem({ commit, state }, id) {
    return await axios.delete(`/api/lineitems/${id}`, { config:{ showToast: false}});
  },
  async updateLineItems({ state }, items) {
    return await axios.post("/api/lineitems/updateitemnumbers", items);
  },
  clearStockSubClass({ commit }) {
    commit("CLEAR_SUB_CLASS");
  },
  clearLineItem({ commit }) {
    commit("CLEAR_LINE_ITEM_DATA");
  },
};
